import { defineComponent as _defineComponent } from 'vue'
import { Customer } from '@/models/tenant';
import { Mode } from '@/models/enums/Mode';
import { ShiftModel } from '@/models/shiftModel';
import { shiftModelsService } from '@/services/shiftModels.service';
import i18n from '@/i18n';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import {
  maxLength,
  required,
  withLocalizedValidators,
} from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftModelFormModal',
  props: {
    customer: null,
    mode: null,
    shiftModel: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  customer: Customer;
  mode: Mode;
  shiftModel: ShiftModel;
};





const editableShiftModel = reactive(ShiftModel.GetEmpty());
const isSubmitting = ref(false);

const validations = {
  name: withLocalizedValidators('form.name', {
    required,
    maxLength: maxLength(256),
  }),
};
const v$ = useVuelidate(validations, editableShiftModel);
const { t } = useI18n();

onMounted(() => {
  if (isCreateMode.value) {
    editableShiftModel.tenantId = props.customer.id;
  } else {
    Object.assign(editableShiftModel, props.shiftModel);
  }
});

async function onSubmit() {
  isSubmitting.value = true;
  try {
    if (isCreateMode.value) {
      await shiftModelsService.create(editableShiftModel);
    } else {
      await shiftModelsService.update(editableShiftModel);
    }
    emit('save');
    emit('close');
  } finally {
    isSubmitting.value = false;
  }
}

function getErrorMessage(key: keyof typeof editableShiftModel) {
  return v$.value[key].$errors?.[0]?.$message;
}

const isEditMode = computed((): boolean => props.mode === Mode.Edit);
const isCreateMode = computed((): boolean => props.mode === Mode.Create);

const actionTitle = computed(() => {
  if (isCreateMode.value) {
    return i18n.t('action.create').toString();
  } else if (isEditMode.value) {
    return i18n.t('action.edit').toString();
  } else {
    return i18n.t('action.close').toString();
  }
});

return { __sfc: true,props, emit, editableShiftModel, isSubmitting, validations, v$, t, onSubmit, getErrorMessage, isEditMode, isCreateMode, actionTitle }
}

})